<div class="switcher-container">
  <button class="switcher-button" (click)="togglePanel()">
    <span class="switcher-icon">&#9776;</span>
    <span class="switcher-text">
      <span *ngIf="currentSiteName" class="current-site-label">{{ currentSiteName }}</span>
      <span *ngIf="!currentSiteName">Switch Dashboard</span>
    </span>
  </button>

  <div class="switcher-panel" [class.open]="isPanelOpen">
    <div class="panel-header">
      <span class="panel-title">Switch Dashboard</span>
    </div>
    <ul *ngIf="mode === 'plant'">
      <li *ngFor="let member of teamMembers; let i = index" 
          (click)="switchUser(member)"
          [class.active]="isCurrentSite(member.site_id)">
        <span class="active-indicator" *ngIf="isCurrentSite(member.site_id)">
          <svg viewBox="0 0 24 24" class="indicator-svg">
            <circle cx="12" cy="12" r="10" class="indicator-outer"/>
            <circle cx="12" cy="12" r="5" class="indicator-inner"/>
          </svg>
        </span>
        <span class="item-name">{{ member.name }}</span>
        <span class="item-badge plant-badge" *ngIf="isCurrentSite(member.site_id)">Active</span>
      </li>
      <li class="plant-dashboard" (click)="switchToPlantDashboard()">
        <span class="material-icons" style="font-size: 18px; margin-right: 8px;">home</span>
        Main Menu
      </li>
    </ul>
    <ul *ngIf="mode === 'executive'">
      <li *ngFor="let executive of executiveMembers; let i = index"
          [class.active]="isCurrentSite(executive.site_id)">
        <a (click)="switchExecutive(executive, executive, i)">
          <span class="active-indicator" *ngIf="isCurrentSite(executive.site_id)">
            <svg viewBox="0 0 24 24" class="indicator-svg">
              <circle cx="12" cy="12" r="10" class="indicator-outer"/>
              <circle cx="12" cy="12" r="5" class="indicator-inner"/>
            </svg>
          </span>
          <span class="item-name">{{ executive.name }}</span>
          <span class="item-badge exec-badge">Executive</span>
          <span class="item-badge active-badge" *ngIf="isCurrentSite(executive.site_id)">Active</span>
        </a>
      </li>
      <li class="plant-dashboard" (click)="switchToPlantDashboard()">
        <span class="material-icons" style="font-size: 18px; margin-right: 8px;">home</span>
        Main Menu
      </li>
    </ul>
  </div>
</div>